import { useQuery } from '@apollo/client';

import { METADATA_QUERY } from '../../app/graphql/miscQueries';
import { extractGraphqlEntity } from '../../common/utils/graphqlUtils';

export function useMetadata() {
  const { data } = useQuery(METADATA_QUERY);
  return data && extractGraphqlEntity(data);
}
